import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ReportAccessTokenService {
  private token: string | null = null;

  constructor() {
    localStorage.removeItem('reportPassword');
  }

  set(token: string | null): void {
    this.token = token || null;
  }

  get(): string | null {
    return this.token;
  }

  clear(): void {
    this.token = null;
  }
}
